import dynamic from 'next/dynamic';

import { useUserTiming } from '@/core/observability/utils/useUserTiming';
import { type NbProductsProps } from '@/productDiscovery/Listings/components/Header/components/NbProducts/NbProducts';
import { NbProductsSkeleton } from '@/productDiscovery/Listings/components/Header/components/NbProducts/NbProductsSkeleton';
import { SortSelect } from '@/productDiscovery/Listings/components/SortSelect/SortSelect';
import { useNbProducts } from '@/productDiscovery/Listings/hooks/useNbProducts';

const DynamicNbProducts = dynamic<NbProductsProps>(
  () =>
    import(
      '@/productDiscovery/Listings/components/Header/components/NbProducts/NbProducts'
    ).then((mod) => mod.NbProducts),
  { loading: () => <NbProductsSkeleton /> },
);

type Props = {
  dataTestId?: string;
  smallNbProducts?: boolean;
};

export const ToolBar = ({ dataTestId, smallNbProducts }: Props) => {
  useUserTiming('ToolBar');
  const nbProducts = useNbProducts();

  return (
    <section
      className="flex flex-row flex-nowrap items-center justify-center
        desktop:justify-between"
    >
      {nbProducts !== undefined ? (
        <DynamicNbProducts dataTestId={dataTestId} revamp={smallNbProducts} />
      ) : (
        <NbProductsSkeleton />
      )}
      <SortSelect />
    </section>
  );
};

ToolBar.displayName = 'ToolBar';
